var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement } from 'lit';
import styles from '../main.js';
import { ScreenController } from './ResizeController';
import { property, state } from 'lit/decorators.js';
import { trackErrorWrapper } from './errorTracking';
import { TranslationController } from './TranslationController';
class BaseComponent extends LitElement {
    constructor() {
        super(...arguments);
        this.screen = new ScreenController(this);
        this._tracked = false;
        this._translationListener = new TranslationController(this, () => {
            this.requestUpdate();
        });
        this.dataTest = '';
    }
    performUpdate() {
        trackErrorWrapper(() => {
            super.performUpdate();
        });
    }
}
BaseComponent.styles = styles;
__decorate([
    property({ type: String })
], BaseComponent.prototype, "position", void 0);
__decorate([
    property()
], BaseComponent.prototype, "dataTest", void 0);
__decorate([
    property({ type: Object })
], BaseComponent.prototype, "vertical", void 0);
__decorate([
    state()
], BaseComponent.prototype, "_error", void 0);
export { BaseComponent };
//# sourceMappingURL=BaseComponent.js.map